import { combineReducers } from 'redux';
import { createPartsCollection } from 'models/Part';
import order from './order';
import parts from './parts';
import monitors from './monitors';
import strings from './strings';
import choices from './choices';
import preferences from './preferences';

export default combineReducers({
  order,
  parts,
  monitors,
  strings,
  choices,
  preferences
});

// TODO - these can cache/memoize the results by using redux/reselect
export const getGeneralStrings = state => state.strings.loadedStrings[state.strings.usingLanguage].general;
export const getFilterStrings = state => state.strings.loadedStrings[state.strings.usingLanguage].filters;
export const getAccessoriesStrings = state => state.strings.loadedStrings[state.strings.usingLanguage].accessories;
export const getPartsStrings = state => state.strings.loadedStrings[state.strings.usingLanguage].parts;
export const getMonitorStrings = state => state.strings.loadedStrings[state.strings.usingLanguage].monitors;
export const getSelectedStrings = state => state.strings.loadedStrings[state.strings.usingLanguage];
export const getMonitors = state => state.monitors.loadedMonitors;
export const getMonitor = (state, monitorId) => state.monitors.loadedMonitors.units[monitorId];

export const getAccessorySequence = (monitor, filterChoices, includeFlexData = false) => {
  const entriesIt = filterChoices.entries();
  let entry = entriesIt.next();
  let sequence = monitor.accessories;
  // strip out filters, flex, etc.
  const stripSequence = (component) => {
    const info = component.split(':');
    if (includeFlexData || info.length > 2) {
      return {
        type: info[0],
        flex: info[1] || 1,
        filter: info[2]
      };
    }
    return info[0];
  };

  while (!entry.done) {
    const { choice } = entry.value[1]; // in a map, 0 = key, 1 = value
    if (choice === '') {
      // this might return the object ie.
      // {
      //   "dräger smart pod connection": ["accessory", "terminal"],
      //   "dräger monitor connection": ["accessory"]
      // }
      if (sequence.default) {
        return sequence.default;
      }
      // strip out :
      return Object.keys(sequence).reduce((acc, key) => ({
        ...acc,
        [key]: sequence[key].map(stripSequence)
      }), {});
    }
    const foundKey = Object.keys(sequence)
      .find(sequenceKey => sequenceKey.split(',').includes(choice));
    sequence = foundKey ? sequence[foundKey] : sequence.default;
    if (!sequence) {
      return [];
    }
    if (Array.isArray(sequence)) {
      return sequence.map(stripSequence);
    }

    entry = entriesIt.next();
  }
  return [];
};

export const getMonitorPatientParameters = monitor => Object.keys(monitor.accessories);

const partsByMonitor = {};
export const getMonitorParts = (state, monitorId) => {
  if (partsByMonitor[monitorId]) {
    return partsByMonitor[monitorId];
  }
  partsByMonitor[monitorId] = createPartsCollection(
    state.parts.loadedParts,
    getMonitor(state, monitorId)
  );
  return partsByMonitor[monitorId];
};

export const getOrderSections = (state) => {
  const sections = [];
  state.order.forEach((partOrder) => {
    const partsCategory = partOrder.part.reviewCategory;
    let inSection = sections.find(section => section.partsCategory === partsCategory);
    if (!inSection) {
      inSection = {
        partsCategory,
        orderList: []
      };
      sections.push(inSection);
    }
    inSection.orderList.push(partOrder);
  });
  return sections;
};


export const getAccessoryChoices = state => state.choices.accessoryChoices;
export const getFilterChoices = state => state.choices.filterChoices;

export const getPartLabel = (partNo, partsStrings) => partsStrings[`${partNo}-label`];
export const getPartDescription = (partNo, partsStrings) => partsStrings[`${partNo}-description`];
